// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--37kBi","footer":"styles-module--footer--2EqRx"};